import React from 'react'

export default function MyMapLabel(props) {
    function getContainerStyle() {
        if(props.isMobileMode)return {display: "none" };    //モバイルモードの場合は非表示
        var margin_lr = 10;
        var content_size = 250;
        var margin = 0;
        if(props.searchPanelVisible){
            if((props.width - (props.width > 400 ? 400 : props.width)) > ((margin_lr * 2) + content_size)){
                margin = (props.width > 400 ? 400 : props.width) + ((props.width - (props.width > 400 ? 400 : props.width)) / 2);
                return {
                    display: "block",
                    margin:"10px -50% 22px "+ margin +"px"
                };
    
            }else{
                return {display: "none" };
            }
        }else{
            if(props.width > ((margin_lr * 2) + content_size)){
                margin = props.width / 2;
                return {
                    display: "block",
                    margin:"10px -50% 22px "+ margin +"px"
                };
    
            }else{
                return {display: "none" };
            }
        }
    }

    return (
        props.overallCount > 0 &&
            <div className="customControlContainer">
                <div className={"customControlDiv " + (props.isMobileMode ? "customControlDiv-mobile" : "")}　style={getContainerStyle()}>
                    <span className="customControlText">全 <strong>{props.overallCount}</strong> 件、</span>
                    <span className="customControlText2">地図内 <strong>{props.allCount}</strong> 件</span>
                    <span className="customControlText3">(表示 {props.hitCount} 件)</span>
                </div>
            </div>
        
    );
}
